import { render, staticRenderFns } from "./subCategoryList.vue?vue&type=template&id=5642b5e7&scoped=true"
import script from "./subCategoryList.vue?vue&type=script&lang=js"
export * from "./subCategoryList.vue?vue&type=script&lang=js"
import style0 from "./subCategoryList.vue?vue&type=style&index=0&id=5642b5e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642b5e7",
  null
  
)

export default component.exports